import { useEffect } from "react";
import { api } from "@/lib/api";

// Injects MusicRecording JSON-LD for every visible single (synced from Apple).
// Mounted once, site-wide. Keeps rich-result eligibility in sync with the DB
// so new releases need no code change.
export default function SinglesAutoSchema() {
  useEffect(() => {
    let cancelled = false;
    api
      .get("/seo/singles-jsonld")
      .then((r) => {
        const graph = r.data && r.data["@graph"];
        if (cancelled || !Array.isArray(graph) || graph.length === 0) return;
        const data = { "@context": "https://schema.org", "@graph": graph };
        let el = document.getElementById("singles-jsonld");
        if (!el) {
          el = document.createElement("script");
          el.type = "application/ld+json";
          el.id = "singles-jsonld";
          document.head.appendChild(el);
        }
        el.textContent = JSON.stringify(data);
      })
      .catch(() => {});
    return () => {
      cancelled = true;
    };
  }, []);
  return null;
}
